import { FileQuestion } from 'lucide-react';
import { ReactElement } from 'react';
import { Button } from '../buttons';
import Link from 'next/link';

interface EmptyPageProps {
  icon?: boolean;
  title?: string;
  description?: string | ReactElement<any>;
  cta?: ReactElement<any> | false;
}

const EmptyPage = ({
  icon = true,
  title = 'Page unavailable',
  description = "The page you're looking for is currently unavailable.",
  cta = (
    <Link href={'/'}>
      <Button variant="solid">Return to home</Button>
    </Link>
  ),
}: EmptyPageProps) => {
  return (
    <div className="flex flex-col items-center">
      {icon && (
        <div
          className={`mt-2 mb-5 rounded-full bg-blue-100 text-blue-800 p-5 ring-8 ring-blue-50`}
        >
          <FileQuestion className="size-6" />
        </div>
      )}
      <div className={`${icon ? 'text-lg' : 'text-2xl'} font-bold mb-3`}>
        {title}
      </div>
      <div className="font-medium text-global-text-secondary text-center">
        {description}
      </div>
      {cta !== false && <div className="mt-6">{cta}</div>}
    </div>
  );
};

export default EmptyPage;
